import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { ExpensesCardWithoutSensitiveInfo } from 'generated/resources/datatable.graphql'
import { getCardTypeColor } from 'modules/expenses/lib/cards/cardTypeColor'
import { getCardTypeLabel } from 'modules/expenses/lib/cards/getCardTypeLabel'
import { CARD_TYPE } from 'modules/expenses/lib/types'

type Props = {
  card: ExpensesCardWithoutSensitiveInfo
}

export const Card = ({ card }: Props) => {
  const { cardType, last4 } = card
  if (!cardType || !last4) {
    return null
  }

  const last4Label = last4 ? ` - ${last4}` : '****'

  return (
    <Box flexDirection="row" alignItems="center" gap="s6">
      <Icon.Medium
        icon="credit-card"
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        color={getCardTypeColor(cardType as CARD_TYPE)}
      />
      <Text.Normal size="200">
        {
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          `${getCardTypeLabel(cardType as CARD_TYPE)} ${last4Label}`
        }
      </Text.Normal>
    </Box>
  )
}
